import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { Card, Button, Alert } from "react-bootstrap";
import axios from "axios";
import { API } from "../../api";

function OrderSummary(props) {
  const [amount, setAmount] = useState(0);
  const [address, setAddress] = useState("");
  const [allAddress, setAllAddress] = useState([]);
  const [view, setView] = useState("");
  const [error, setError] = useState("");
  const [noitem, setNoitem] = useState(false);
  const [flag, setFlag] = useState(true);

  useEffect(() => {
    let sum = 0;
    props.cart.forEach(
      (item) => (sum += item.discounted_price * item.quantity)
    );
    if (flag) {
      if (props.cart.length === 0) {
        setNoitem(true);
        setFlag(false);
      } else {
        setNoitem(false);
        setFlag(false);
      }
    }
    setAmount(sum);
  }, [props.cart, flag]);

  useEffect(() => {
    if (props.token) {
      axios(`${API}addresses/`, {
        headers: { Authorization: `Bearer ${props.token}` },
      })
        .then((res) => setAllAddress(res.data))
        .catch((err) => {
          // console.log(err.response.data);
        });
    }
  }, [props.token]);

  const myError = (msg) => {
    setError(`${msg}`);
    setTimeout(() => {
      setError("");
    }, 2000);
  };

  const handelRadio = (id) => {
    setAddress(id);
  };

  const handelView = (value) => {
    setView(value);
  };

  const handelOrderPlaced = () => {
    if (address) {
      props.cart.forEach((item) => {
        axios
          .post(
            `${API}orders/`,
            {
              address,
              product: item.id,
              quantity: item.quantity,
              amount: item.quantity * item.discounted_price,
            },
            { headers: { Authorization: `Bearer ${props.token}` } }
          )
          .then((res) => {
            setNoitem(false);
            handelView("success");
          })
          .catch((err) => {
            // console.log(err.response.data);
          });
      });
      props.orderPlaced();
    } else {
      myError("Please Select An Address");
    }
  };

  return (
    <div className="container my-3 mx-auto">
      {noitem ? (
        <div>
          <p className="bg-danger text-center text-white py-3">
            You Cart Is Empty. <br />
            Please Purchase Any Product To Place Order.
          </p>
        </div>
      ) : view === "success" ? (
        <div>
          <p className="bg-primary text-center py-3 text-white h3">
            Your Order Placed Successfully !!!
          </p>{" "}
        </div>
      ) : (
        <div className="row">
          <div className="col-md-6 py-3">
            <p className="fw-bold h5 px-2 px-sm-3">Order Summary </p>
            <hr style={{ marginTop: "-5px", hieght: "2px" }} />
            {props.cart.map((item, i) => {
              return (
                <div key={item.id} className="px-3">
                  <p className="m-0"> &bull; Product {i + 1}</p>
                  <div className="px-4">
                    <p className="m-0">Name : {item.title}</p>
                    <p className="m-0">Quantity : {item.quantity}</p>
                    <p>Price : {item.discounted_price * item.quantity}</p>
                  </div>
                </div>
              );
            })}
            <div className="fw-bold mb-2">The Total Amount Is :{amount}</div>
            <hr style={{ marginTop: "-5px", hieght: "2px" }} />
          </div>
          <div
            className="col-md-6 py-3 "
            style={{ borderLeft: "2px solid gray" }}
          >
            <p className="fw-bold h5 px-2 px-sm-3">Select Shipping Address </p>
            <hr style={{ marginTop: "-5px", hieght: "2px" }} />

            <div>
              {allAddress.map((item, i) => {
                return (
                  <div key={item.id} className="mb-3">
                    <Card>
                      <Card.Body>
                        <p className="m-0">
                          {item.first_name} {item.last_name}
                        </p>
                        <p className="m-0" style={{ fontSize: "13px" }}>
                          {item.address}
                        </p>
                        <p style={{ fontSize: "13px" }}>{item.zipcode}</p>
                        <label>
                          <input
                            type="radio"
                            name="selecteAddress"
                            onClick={() => {
                              handelRadio(item.id);
                            }}
                          />{" "}
                          Address {i + 1}
                        </label>
                      </Card.Body>
                    </Card>
                  </div>
                );
              })}
            </div>
            <div className="my-3">
              <Link to="/profile">
                <Button variant="dark" className="">
                  Add New Address
                </Button>
              </Link>
            </div>
          </div>
          <div>
            <p className="fw-bold h5 px-2 px-sm-3">Payment Options</p>
            <hr style={{ marginTop: "-5px", hieght: "2px" }} />
            <div>
              <button
                type="button"
                className="w-100 border-0"
                onClick={() => {
                  handelView("paypal");
                }}
              >
                <p
                  className="fw-bold fst-italic py-2 text-center"
                  style={{
                    backgroundColor: "#fec230",
                    color: "#222D65",
                    margin: "0px",
                  }}
                >
                  Pay<span style={{ color: "#3b7bbf" }}>Pal</span>
                </p>
              </button>
              {view === "paypal" && (
                <div className="mt-3">
                  <button
                    type="button"
                    className="btn btn-primary w-100"
                    onClick={handelOrderPlaced}
                  >
                    Pay Rs. {amount}
                  </button>
                  {error && (
                    <Alert variant="danger" className="mt-3 mb-0">
                      {error}
                    </Alert>
                  )}
                </div>
              )}
              <button
                type="button"
                className="w-100 border-0 my-3"
                onClick={() => {
                  handelView("debit");
                }}
              >
                <p className="bg-dark py-2 text-white text-center m-0">
                  Credit Card Or Debit Card
                </p>
              </button>
              {view === "debit" && (
                <div className="mb-3">
                  <button
                    type="button"
                    className="btn btn-primary w-100"
                    onClick={handelOrderPlaced}
                  >
                    Pay Rs. {amount}
                  </button>
                  {error && (
                    <Alert variant="danger" className="mt-3 mb-0">
                      {error}
                    </Alert>
                  )}
                </div>
              )}
              <button
                type="button"
                className="w-100 border-0"
                onClick={() => {
                  handelView("cod");
                }}
              >
                <p className="py-2 text-center bg-dark text-white">
                  Cash On Delivery
                </p>
              </button>
              {view === "cod" && (
                <div>
                  <button
                    type="button"
                    className="btn btn-primary w-100"
                    onClick={handelOrderPlaced}
                  >
                    Pay Rs. {amount}
                  </button>
                  {error && (
                    <Alert variant="danger" className="mt-3 mb-0">
                      {error}
                    </Alert>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    cart: state.cart,
    address: state.address,
    token: state.userDetails.token,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    orderPlaced: (val) => dispatch({ type: "CART_ORDER_PLACED", payload: val }),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(OrderSummary);
